export const Finland = {
    name: "Finland",
    image: "/Finland.avif",
    overview: {
        title: "Why Bangladeshi Students Choose Finland for Higher Studies?",
        descriptions: [
            "Bangladeshi students choose Finland for its world-renowned education system, innovative teaching methods, and excellent research opportunities. The country offers high-quality education with a focus on practical learning and innovation.",
            "Finland's strong emphasis on equality, sustainability, and technology makes it an ideal destination for students seeking cutting-edge education in a safe, progressive environment."
        ],
    },
    highlights: [
        {
            icon: "fas fa-city",
            title: "Student-friendly cities",
            description: "Helsinki ranks among the top student cities globally, known for its excellent universities and high quality of life."
        },
        {
            icon: "fas fa-briefcase",
            title: "Post-study work rights",
            description: "Finland offers up to 1 year of post-study work opportunities for international graduates."
        },
        {
            icon: "fas fa-graduation-cap",
            title: "Top universities",
            description: "Finland has 9 universities in the QS World University Rankings, with University of Helsinki ranking in the top 150."
        },
        {
            icon: "fas fa-users",
            title: "Innovation hub",
            description: "Finland's education system emphasizes innovation, technology, and practical learning with strong industry connections."
        }
    ],
    keyFacts: [
        { factNumber: "13", factLabel: "Universities" },
        { factNumber: "25,000", factLabel: "International Students in Finland in 2024" },
        { factNumber: "25 Hours", factLabel: "Per week Part-time work permit" },
        { factNumber: "1 Year", factLabel: "Post-study work permit" }
    ],
    stats: {
        capital: "Helsinki",
        poplulation: "5.6 million",
        economicGrowthRate: "2.0%",
        currency: "Euro (EUR)",
        language: "Finnish (English widely spoken)",
        weather: [
            "Helsinki: 12°C - 20°C",
            "Tampere: 11°C - 19°C",
            "Turku: 12°C - 19°C",
            "Oulu: 10°C - 18°C"
        ]
    },
    requirements: [
        "Academic transcripts",
        "English proficiency test scores (IELTS, TOEFL, Cambridge)",
        "Motivation letter",
        "Curriculum Vitae",
        "Valid passport copy",
        "Proof of finances (Bank statements)",
        "Health insurance",
        "Portfolio (for design/arts programs)"
    ],
    intake: {
        title: "Finnish universities offer two main intakes:",
        intakes: [
            {
                name: "Autumn Intake",
                month: "Starts in August/September"
            },
            {
                name: "Spring Intake",
                month: "Starts in January/February (Limited programs)"
            }
        ]
    },
    programs: [
        {
            name: "Bachelor's Degree",
            duration: "3 years"
        },
        {
            name: "Master's Degree",
            duration: "2 years"
        },
        {
            name: "PhD",
            duration: "4 years"
        },
        {
            name: "Polytechnic Degree",
            duration: "3.5-4 years"
        }
    ],
    popularPrograms: {
        title: "Finland offers high-quality education with focus on innovation and technology. Popular programs for international students include:",
        programs: [
            "Information Technology",
            "Engineering",
            "Business Administration",
            "Design",
            "Environmental Science",
            "Education",
            "Medicine",
            "Social Sciences",
            "Gaming Technology"
        ]
    },
    costs: [
        {
            program: "Foundation/Pathway",
            local: "EUR 8,000 - 12,000",
            bdt: "8,80,000 – 13,20,000 BDT"
        },
        {
            program: "Undergraduate Courses",
            local: "EUR 8,000 - 18,000",
            bdt: "8,80,000 – 19,80,000 BDT"
        },
        {
            program: "Postgraduate Courses",
            local: "EUR 10,000 - 20,000",
            bdt: "11,00,000 – 22,00,000 BDT"
        },
        {
            program: "PhD Programs",
            local: "Free (with stipend)",
            bdt: "Free with monthly stipend"
        }
    ],
    topCities: {
        title: "Finland offers excellent education in several vibrant cities with high quality of life. Key student cities include:",
        cities: [
            {
                name: "Helsinki",
                description: "Capital city with top universities and vibrant tech scene"
            },
            {
                name: "Tampere",
                description: "Industrial city with excellent university and research facilities"
            },
            {
                name: "Turku",
                description: "Historic city with growing university presence and innovation focus"
            },
            {
                name: "Oulu",
                description: "Northern city with strong technology and engineering programs"
            },
            {
                name: "Jyväskylä",
                description: "University town with focus on education and social sciences"
            },
            {
                name: "Vaasa",
                description: "Coastal city with business and energy programs"
            }
        ]
    },
    workOptions: {
        partTimeWork: "International students can work up to 25 hours per week during study periods and full-time during breaks. Students typically earn EUR 10-15 per hour. The work experience in Finland's innovative companies can be highly valuable.",
        postStudyWork: "The Residence Permit for Job Seeking allows graduates to stay and work in Finland for up to 1 year after graduation. This provides an excellent opportunity to gain work experience in Finland's strong economy and potentially qualify for permanent residency."
    },
    faqs: [
        {
            question: "How do I apply for a student visa in Finland?",
            answer: "To apply for a student visa, you need an acceptance letter from a Finnish institution, proof of English proficiency, financial capacity (EUR 560 per month), health insurance, and a completed visa application form. The application is processed through the Finnish Immigration Service."
        },
        {
            question: "What are the English language requirements for studying in Finland?",
            answer: "Most Finnish institutions require IELTS (6.0-6.5), TOEFL (80-90), or Cambridge (B2-C1) scores. Some programs may require higher scores, especially for competitive programs."
        },
        {
            question: "Can I work while studying in Finland?",
            answer: "Yes, international students can work up to 25 hours per week during study periods and full-time during breaks. The Residence Permit for Job Seeking allows graduates to work after completing their studies."
        },
        {
            question: "Are scholarships available for international students in Finland?",
            answer: "Yes, there are various scholarships offered by the Finnish government, universities, and external organizations. These include the Finnish Government Scholarship Pool, university-specific scholarships, and EU/EEA mobility programs."
        },
        {
            question: "How much does it cost to study in Finland from Bangladesh?",
            answer: "Studying in Finland from Bangladesh costs around EUR 8,000-20,000 for tuition, EUR 700-900 per month for living expenses, and EUR 100-200 for health insurance annually. Total annual cost ranges from EUR 16,000-30,000."
        },
        {
            question: "What GPA is required to study in Finland from Bangladesh?",
            answer: "To study in Finland from Bangladesh, the required GPA typically ranges from <strong>3.0 to 3.5</strong> on a 4.0 scale for undergraduate programs and <strong>3.2 to 3.7</strong> for postgraduate programs, depending on the university and program competitiveness."
        }
    ]
}
